import { CSSObject } from "@mantine/core";
import { pxToRem } from "theme/spacing";

export type SizeVariant = "small" | "large";

export const baseStyles: CSSObject = {
  fontWeight: 600,
  letterSpacing: "0.01em",
  height: "auto",
  padding: `${pxToRem[8]} ${pxToRem[20]} ${pxToRem[8]} ${pxToRem[20]}`,
};

export const sizeVariants: Record<SizeVariant, CSSObject> = {
  large: {
    ...baseStyles,
    fontSize: pxToRem[16],
    lineHeight: pxToRem[24],
  },
  small: {
    ...baseStyles,
    fontSize: pxToRem[14],
    lineHeight: pxToRem[20],
  },
} as const;
